<template>
    <div id="loginPage">
        <div
            class="d-flex flex-column rounded align-items-center text-center py-4 px-lg-5 px-3 bg-white"
        >
            <transaction-details
                :transaction="transaction"
                :amount="transaction.amount"
            />
        </div>
        <div class="d-flex flex-column rounded align-items-center text-center py-4 px-3 bg-white my-2">
            <span class="font-md font-weight-bold text-gray-dk mb-2">{{EnumLabels.CONTINUE_TO_PAYMENT}}</span>
            <span class="font-xs text-secondary">Login securely to your Home Credit app to pay.</span>
            <info-bar class="mt-4 mb-2">For selected existing Home Credit customers only</info-bar>
            <div class="col-10 col-xl-7 col-lg-8 col-sm-12 mt-4 mb-4">
                <button type="button" id="loginMobileBtn" class="btn btn-danger btn-block rounded-lg py-2 mb-4" @click="changeView('mobile')">
                    <img alt="" src="/img/hcpay/Phone.svg" class="img-responsive float-left" style="height:auto;width:1.5rem">
                    <span class="font-sm text-center">{{EnumLabels.CONTINUE_WITH_MOBILE_NO}}</span>
                </button>
            </div>
            <terms-and-conditions
                terms-and-condition-id="loginTermsAndCondition"
                class="mb-3"
            />
            <cancel-request
                id="loginBackToStore"
                :cancelGtmEventName="this.cancelEventName"
            ></cancel-request>
        </div>
        <div class="d-flex flex-column rounded align-items-center px-0 py-4 bg-white">
            <download-opg-v3 class="px-4" google-play-id="loginGooglePlayBtn" qr-code-id="loginQRCode"></download-opg-v3>
            <hr class="mt-5 mb-4">
            <learn-more learn-more-id="loginLearnMore" class="px-4"></learn-more>
        </div>
    </div>
</template>
<script>
import { analyticsDirective } from '../directives/analytics.js';
import { ERROR } from '../mixins/error_codes.js';
import { EnumLabels } from '../enums/CommonString.js';
export default {
    data() {
        return {
            EnumLabels,
            transaction: this.$root.$data.transaction,
            cancelEventName: "landing_click_cancel_go_back",
            downloadEventName: "landing_install_hc_app"
        };
    },
    directives: {
        analytics: analyticsDirective
    },
    methods: {
        changeView(view) {
            let g4params = {
                ip: this.$root.transaction.ipAddress,
                user_agent: this.$root.$data.analyticsData.userAgent,
                phone: this.$root.$data.analyticsData.phone,
                operating_system:
                    this.$root.$data.analyticsData.operatingSystem.name +
                    "V" +
                    this.$root.$data.analyticsData.operatingSystem.version,
                browser:
                    this.$root.$data.analyticsData.browser.name +
                    "V" +
                    this.$root.$data.analyticsData.browser.version,
                transaction_type: this.$root.$data.transaction.referenceNumber.substring(
                    0,
                    2
                ),
                transaction_reference: this.$root.$data.transaction
                    .referenceNumber
            };
            this.$root.triggerG4Event(
                "landing_click_cont_mobile_num",
                g4params
            );
            this.$root.$data.view = view;
        }
    },
    created() {
        let g4params = {
            ip: this.$root.transaction.ipAddress,
            user_agent: this.$root.$data.analyticsData.userAgent,
            phone: this.$root.$data.analyticsData.phone,
            operating_system:
                this.$root.$data.analyticsData.operatingSystem.name +
                "V" +
                this.$root.$data.analyticsData.operatingSystem.version,
            browser:
                this.$root.$data.analyticsData.browser.name +
                "V" +
                this.$root.$data.analyticsData.browser.version,
            transaction_type: this.$root.$data.transaction.referenceNumber.substring(
                0,
                2
            ),
            transaction_reference: this.$root.$data.transaction.referenceNumber
        };
        this.$root.triggerG4Event("landing_page", g4params);
        this.$root.$data.previousView = "home";

        sessionStorage.setItem("ip", this.$root.transaction.ipAddress);
        sessionStorage.setItem(
            "transaction_type",
            this.$root.$data.transaction.referenceNumber.substring(0, 2)
        );
        sessionStorage.setItem(
            "transaction_reference",
            this.$root.$data.transaction.referenceNumber
        );
        sessionStorage.setItem(
            "user_agent",
            this.$root.$data.analyticsData.userAgent
        );
        sessionStorage.setItem("phone", this.$root.$data.analyticsData.phone);
        sessionStorage.setItem(
            "operating_system",
            this.$root.$data.analyticsData.operatingSystem.name +
                "V" +
                this.$root.$data.analyticsData.operatingSystem.version
        );
        sessionStorage.setItem(
            "browser",
            this.$root.$data.analyticsData.browser.name +
                "V" +
                this.$root.$data.analyticsData.browser.version
        );
    }
};
</script>
